import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IUserPassword } from "./routeType";

const { key, getPath } = getApi("users.password.reset.confirm.post");

type IExtractedRouteType = IUserPassword["userSingleUpdatePassword"];

export type IChangePassword = IPickMutation<IExtractedRouteType>;

const changePassword: Fetcher<
  IChangePassword["response"],
  IChangePassword["variables"]
> = (data) => {
  return axiosClient.post(getPath(), data);
};

export const useChangePassword = createQuery({
  queryKey: [key],
  fetcher: changePassword,
});
